import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import { ROUTES } from "../../constants/clientRoutes";
import i18n from "../../i18n/config";
import { SetSelectedRecipient, SetSendMoneyCountryCurrency } from "../../actions/sendMoney";
import { ACTION_DISPLAY_TYPES } from "../../constants/enums";

// types 
import { SendMoneyRecipientAccount, SendMoneyTransferMethodId } from "../../types/sendMoney";

// ui components
import FlowScreen from "../../components/Layouts/FlowScreen";
import RecipientCard from "../../components/SendMoney/RecipientCard";
import SingleColumnLayout from "../../components/Layouts/SingleColumnLayout";
import Action from "../../components/Common/Action";

const SendMoneyRecipients = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation<{ accounts: SendMoneyRecipientAccount[] }>();
  const transferMethod = useSelector((state: any) => state.sendMoney.transferMethod) as SendMoneyTransferMethodId | null;
  const accounts = location.state?.accounts ?? [];

  if (!accounts.length || !transferMethod) {
    return <Redirect to={ROUTES.MY_CARD.INDEX} />;
  }

  return (
    <FlowScreen
      flowTitle={i18n.t("PAGES.SEND_MONEY.RECIPIENTS.TITLE")}
      showBackButton={true}
      className="v3"
      headerAction={
        <Action
          title={i18n.t("PAGES.SEND_MONEY.RECIPIENTS.BUTTON_TEXT")}
          onClick={() => {
            // new recipient: start clean — a saved recipient's corridor must not prefill the form
            dispatch(SetSelectedRecipient(null));
            dispatch(SetSendMoneyCountryCurrency({ country: "", currency: "" }));
            history.push(ROUTES.SEND_MONEY.COUNTRY_CURRENCY_SELECTION);
          }}
          displayType={ACTION_DISPLAY_TYPES.PRIMARY}
        />
      }
    >
      <SingleColumnLayout>
        {accounts.map((recipient) => (
          <RecipientCard key={recipient.accountId} recipient={recipient} transferMethod={transferMethod} />
        ))}
      </SingleColumnLayout>
    </FlowScreen>
  );
};

export default SendMoneyRecipients;